import { Pipe, PipeTransform } from '@angular/core';
import { CloudinaryTransformPipe } from './cloudinary-transform.pipe';

@Pipe({ name: 'cloudinaryVideoTransform' })
export class CloudinaryVideoTransformPipe extends CloudinaryTransformPipe implements PipeTransform {
	type: 'video' | 'image' = 'video';
}
